import { Pressable, View } from "react-native";
import { control, useTheme } from "~/styles/theme";
import { BodyText } from "./Text";

export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
}: {
  options: { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
}) {
  const { colors } = useTheme();
  return (
    <View
      style={{
        flexDirection: "row",
        borderWidth: 1,
        borderColor: colors.ruleStrong,
      }}
    >
      {options.map((option, index) => {
        const selected = option.value === value;
        return (
          <Pressable
            key={option.value}
            accessibilityRole="button"
            accessibilityLabel={option.label}
            accessibilityState={{ selected }}
            onPress={() => onChange(option.value)}
            style={{
              flex: 1,
              height: control.height,
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: selected ? colors.ink : "transparent",
              borderLeftWidth: index === 0 ? 0 : 1,
              borderLeftColor: colors.ruleStrong,
            }}
          >
            <BodyText
              weight="semibold"
              color={selected ? colors.inverse : colors.ink}
            >
              {option.label}
            </BodyText>
          </Pressable>
        );
      })}
    </View>
  );
}
